export function isSameFrame(a: ImageData, b: ImageData) {
  if (a.data.length !== b.data.length) {
    return false
  }
  const max = a.data.length
  for (let i = 0; i < max; i++) {
    if (a.data[i] !== b.data[i]) {
      return false
    }
  }
  return true
}

export function toGray(imageData: ImageData) {
  for (let i = 0; i < imageData.data.length; i += 4) {
    const r = imageData.data[i]
    const g = imageData.data[i + 1]
    const b = imageData.data[i + 2]

    const gray = parseInt(`${(r + g + b ) / 3}`, 10)
    imageData.data[i] = gray
    imageData.data[i + 1] = gray
    imageData.data[i + 2] = gray
  }
  return imageData
}

export function downloadFile(file: File) {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(file)
  a.href = url
  a.download = file.name
  a.click()
  window.URL.revokeObjectURL(url)
}
